"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = exports.SeeAllResults = exports.SectionLabel = exports.Section = exports.Root = exports.Queries = exports.Products = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  height: '100%',
  padding: theme.spacing(0, 3),
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    borderRadius: theme.spacing(3),
    overflow: 'hidden',
    padding: theme.spacing(0, 3, 10, 3)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
  boxSizing: 'border-box',
  padding: theme.spacing(0, 0, 3, 0),
  overflowY: 'auto',
  [theme.breakpoints.up('md')]: {
    maxHeight: '100%',
    padding: theme.spacing(4, 3, 0, 3)
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(4, 3, 0, 3)
  }
}));
const Queries = exports.Queries = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'auto',
  flexWrap: 'nowrap',
  scrollbarWidth: 'none',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(3),
  maxWidth: '100%',
  [theme.breakpoints.up('md')]: {
    flexWrap: 'wrap',
    overflowX: 'visible'
  }
}));
const Products = exports.Products = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
const SeeAllResults = exports.SeeAllResults = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'fixed',
  bottom: '0',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(3, 0),
  left: 0,
  [theme.breakpoints.up('md')]: {
    position: 'absolute'
  }
}));
const StyledDivider = exports.StyledDivider = (0, _mui.styled)(_mui.Divider)(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[200],
  margin: theme.spacing(3, 0),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(1, 0)
  }
}));
const Section = exports.Section = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  withPaddingBottom
}) => ({
  paddingBottom: withPaddingBottom ? theme.spacing(3) : 0,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(2)
}));
const SectionLabel = exports.SectionLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold
}));
